import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

import { ProjectFilterService } from '@core/services/project-filter.service';
import { FilterStoreService } from '@core/services/store/filter.store.service';
import { map } from 'rxjs/operators';

import { FilterPopupComponent } from '../filter-popup/filter-popup.component';

@Component({
  selector: 'app-filter-controls',
  templateUrl: './filter-controls.component.html',
  styleUrls: ['./filter-controls.component.less'],
  standalone: true,
  imports: [FilterPopupComponent],
  providers: [FilterStoreService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterControlsComponent {
  private readonly filterStoreService = inject(FilterStoreService);
  private readonly projectFilterService = inject(ProjectFilterService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  /** Включена ли фильтрация */
  protected readonly isFilteringEnabled = toSignal(
    this.route.queryParamMap.pipe(
      map(params => {
        // Исключаем служебный параметр autoFilter из проверки
        const hasResponsibleId = params.has('responsibleId');
        const hasAuthorId = params.has('authorId');
        const hasTagId = params.has('tagId');
        const hasStatusId = params.has('statusId');
        const hasText = params.has('text');

        return hasResponsibleId || hasAuthorId || hasTagId || hasStatusId || hasText;
      })
    ),
    { initialValue: false }
  );

  /**
   * Показывать ли попап фильтров
   */
  protected readonly isShowFilterPopup = signal(false);

  /**
   * Открыть/закрыть попап фильтров
   */
  protected onToggleFilterPopup(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.isShowFilterPopup.update(value => !value);
  }

  /**
   * Закрыть попап фильтров
   */
  protected onCloseFilterPopup(): void {
    this.isShowFilterPopup.set(false);
  }

  /**
   * Сбросить фильтр
   */
  protected onClearFilter(): void {
    // Очищаем сохраненный фильтр проекта
    this.route.parent?.parent?.params.subscribe(params => {
      const projectId = params['projectId'];
      if (projectId) {
        this.projectFilterService.clearProjectFilter(projectId);
      }
    });

    this.filterStoreService.selectFilter(null);
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
  }
}
